import React from 'react'
import { segSearch } from '../../../assets'

export default function SearchAlert({ text }) {
  return (
    <div className='tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center'>
      <img className='img-search-alert' src={segSearch} title='Pesquisar' alt='' />
      <p className='text-label-padrao tw-w-full tw-text-center'>{text}</p>
    </div>
  )
}
